<div>
    <nav #navRef class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top d-flex flex-column p-0 align-items-start">
        <div class="container-fluid w-100 px-3 py-2 d-flex justify-content-between align-items-center">
            <!-- Logo -->
            <a class="navbar-brand" [routerLink]="['/public/home']" aria-label="Inicio - Página principal" appLenguajeSenasVideo videoSrc="assets/accesibilidad/home/63. Inicio.mp4" textoAlternativo="Inicio" posicionVideo="bottom">
                <img src="assets/img/logos/Logo_CulturedBogota.png" alt="Logo Cultured" class="logo" />
            </a>

            <!-- Toggle button for mobile -->
            <button class="navbar-toggler" type="button" aria-label="Menú desplegable" data-bs-toggle="collapse" data-bs-target="#mainNav" aria-controls="mainNav">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- Main menu -->
            <div class="collapse navbar-collapse justify-content-between" id="mainNav">
                <!-- Opcional: enlaces de navegación -->
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                </ul>

                <!-- Usuario o Login -->
                <div *ngIf="showBtnLogin">
                    <a appLenguajeSenasVideo videoSrc="assets/accesibilidad/home/52. Iniciar sesión.mp4" textoAlternativo="Iniciar Sesión" posicionVideo="bottom" class="btn btn-outline-primary" [routerLink]="['/public/auth']">Iniciar Sesión</a>
                </div>

                <div *ngIf="!showBtnLogin" class="dropdown">
                    <button class="btn btn-outline-primary dropdown-toggle" type="button" aria-haspopup="true" (click)="toggleMenu()" [attr.aria-expanded]="showMenu" (keydown)="onKeydownToggle($event)">
                        {{ email }}
                    </button>

                    <ul class="dropdown-menu dropdown-menu-end" [class.show]="showMenu" role="menu">
                        <li><a class="dropdown-item" role="menuitem" *ngIf="isAdmin" [routerLink]="['/private/profile/reports']">Administrador</a></li>
                        <li><a class="dropdown-item" role="menuitem" [routerLink]="['/private/profile']">Perfil de usuario</a></li>
                        <li><a class="dropdown-item" role="menuitem" [routerLink]="['/private/profile/additional-information']">Datos personales</a></li>
                        <li><hr class="dropdown-divider" /></li>
                        <li><button class="dropdown-item text-danger" (click)="closeSession()">Cerrar Sesión</button></li>
                    </ul>
                </div>
            </div>
        </div>
        <app-breadcrumb style="padding-right: 2px"></app-breadcrumb>
    </nav>
</div>
